var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-row align-items-end" }, [
    _vm.$mods.billing.access_all_families &&
    _vm.can(_vm.PERMISSIONS.ACCESS_ALL_FAMILIES)
      ? _c(
          "div",
          { staticClass: "col-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.branch"),
                options: _vm.SchoolsForSelect,
                name: "school",
                model: _vm.localFilters,
                "label-field": "name",
                "value-field": "id",
                reduce: (value) => value.id,
                multiple: _vm.isSuperadminLoggedSchool,
                selectAllOption: false,
              },
              on: {
                change: (e) => {
                  _vm.loadAllDataToSelects()
                  _vm.updateSelectedNames()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showAcademicYear
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.academic_year"),
                options: _vm.academicYears,
                name: "academicYear",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
              on: {
                change: (e) => {
                  _vm.clearInput("academicYear")
                  _vm.setEnrollment()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showAnotherAcademicYear
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.another_academic_year"),
                reduce: (value) => value.id,
                options: _vm.academicYears,
                name: "doesnotHaveAcademicYearEnrollment",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.stage"),
            options: _vm.stagesForSelect,
            name: "stageEnrollment",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            reduce: (value) => value.id,
          },
          on: {
            change: function ($event) {
              return _vm.getYearLevels()
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.yearLevel"),
            options: _vm.yearLevelForSelect,
            name: "yearLevelEnrollment",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            reduce: (value) => value.id,
          },
          on: {
            change: (e) => {
              _vm.getClasses()
              _vm.updateSelectedNames()
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.class"),
            options: _vm.classes,
            name: "classEnrollment",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            reduce: (value) => value.id,
          },
          on: {
            change: (e) => {
              _vm.clearInput("class")
              _vm.updateSelectedNames()
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.religion"),
            reduce: (value) => value.id,
            options: _vm.religionsForSelect,
            name: "religion",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.enrolled_year"),
            options: _vm.academicYears,
            name: "enrolledAcademicYear",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
          },
          on: {
            change: function ($event) {
              return _vm.clearInput("enrolledAcademicYear")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.gender"),
            reduce: (value) => value.id,
            options: _vm.genderForSelect,
            name: "gender",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.nationality"),
            reduce: (value) => value.name_en,
            options: _vm.nationalitiesForSelect,
            name: "nationalityKeyword",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            disabled: _vm.unspecifiedNationalityStatus,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.student_type"),
            options: _vm.studentTypesForSelect,
            name: "studentType",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            reduce: (value) => value.id,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.route != "/students/report/transformation-students"
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.student_status"),
                reduce: (value) => value.id,
                options: _vm.studentStatus,
                name: "status",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.previousSchool &&
    _vm.route == "/students/report/transformation-students"
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.transform_school"),
                options: _vm.prevSchoolsForSelect,
                name: "transformSchool",
                model: _vm.localFilters,
                reduce: (value) => value.id,
                errors: _vm.formErrors,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.registration_status"),
            options: _vm.registrationStatusForSelect,
            name: "registrationType",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            reduce: (val) => val.id,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.studyStatus
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.study_status"),
                options: _vm.studyStatusForSelect,
                name: "studyStatus",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (val) => val.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.select_district"),
            options: _vm.districts,
            name: "districtId",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            reduce: (val) => val.id,
          },
          on: {
            change: _vm.getArea,
            keyup: function ($event) {
              return _vm.clearInput("district")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.select_area"),
            options: _vm.areas,
            name: "areaId",
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
            reduce: (val) => val.id,
          },
          on: {
            keyup: function ($event) {
              return _vm.clearInput("area")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-3" },
      [
        _c("form-input", {
          attrs: {
            label: _vm.Lang.get("messages.student_code"),
            name: "code",
            model: _vm.localFilters,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-3" },
      [
        _c("form-input", {
          attrs: {
            label: _vm.Lang.get("messages.student_civil_id"),
            name: "civilId",
            model: _vm.localFilters,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-3" },
      [
        _c("form-input", {
          attrs: {
            label: _vm.Lang.get("messages.father_civil_id"),
            name: "fatherCivilId",
            model: _vm.localFilters,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.$mods.school_settings.families.father.form_inputs.work_sector
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.father_work_sector"),
                name: "fatherWorkSectorKeyword",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$mods.school_settings.families.father.form_inputs.work_sector_type
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.father_work_sector"),
                options: _vm.workSectorTypesForSelect,
                name: "fatherWorkSectorType",
                model: _vm.localFilters,
                reduce: (value) => value.id,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$mods.school_settings.families.mother.form_inputs.work_sector
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.mother_work_sector"),
                name: "motherWorkSectorKeyword",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$mods.school_settings.families.mother.form_inputs.work_sector_type
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.mother_work_sector"),
                options: _vm.workSectorTypesForSelect,
                name: "motherWorkSectorType",
                model: _vm.localFilters,
                reduce: (value) => value.id,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.medical_file_availability"),
            options: _vm.boolOptions,
            name: "medicalFileAvailability",
            reduce: (value) => value.id,
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-select", {
          attrs: {
            label: _vm.Lang.get("messages.working_sons"),
            options: _vm.boolOptions,
            name: "isParentStaff",
            reduce: (value) => value.id,
            model: _vm.localFilters,
            errors: _vm.formErrors,
            "label-field": "name",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-date", {
          attrs: {
            label:
              _vm.Lang.get("messages.from_") +
              " " +
              _vm.Lang.get("messages.join_date"),
            name: "fromJoinedDate",
            model: _vm.localFilters,
            errors: _vm.formErrors,
          },
          on: {
            change: function ($event) {
              return _vm.clearInput("joinedDate")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-date", {
          attrs: {
            label:
              _vm.Lang.get("messages.to_") +
              " " +
              _vm.Lang.get("messages.join_date"),
            name: "toJoinedDate",
            model: _vm.localFilters,
            errors: _vm.formErrors,
          },
          on: {
            change: function ($event) {
              return _vm.clearInput("joinedDate")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-date", {
          attrs: {
            label: _vm.Lang.get("messages.from_date"),
            name: "hasInvoicesTransactionsFromDate",
            model: _vm.localFilters,
            errors: _vm.formErrors,
          },
          on: {
            change: function ($event) {
              return _vm.clearInput("fromDate")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-3" },
      [
        _c("form-date", {
          attrs: {
            label: _vm.Lang.get("messages.to_date"),
            name: "hasInvoicesTransactionsToDate",
            model: _vm.localFilters,
            errors: _vm.formErrors,
          },
          on: {
            change: function ($event) {
              return _vm.clearInput("toDate")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.from_balance
      ? _c(
          "div",
          { staticClass: "col-md-2" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.from_number"),
                name: "from",
                type: "number",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.to_balance
      ? _c(
          "div",
          { staticClass: "col-md-2" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.to_number"),
                name: "to",
                type: "number",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.expenseAt
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label:
                  _vm.Lang.get("messages.expense_at") +
                  "(" +
                  _vm.Lang.get("messages.registration") +
                  ")",
                options: _vm.expenseTypesForSelect,
                name: "expenseAt",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.previousSchool
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.school_type"),
                "label-field": "name",
                "value-field": "id",
                reduce: (value) => value.id,
                options: _vm.schoolTypes,
                name: "schoolType",
                model: _vm.localFilters,
              },
              on: {
                change: function ($event) {
                  return _vm.getPrevSchools()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.previousSchool && _vm.route != "/students/report/transformation-student"
      ? _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.external_school"),
                options: _vm.prevSchoolsForSelect,
                name: "previousSchool",
                model: _vm.localFilters,
                reduce: (value) => value.id,
                errors: _vm.formErrors,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }